import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '../../pipes/pipes.module';
import { MaxValueValidator } from './validators/max-validator.directive';
import { MinValueValidator } from './validators/min-validator.directive';
import { NumberInputDirective } from './number-input.directive';
import { InputDirective } from './input.directive';
import { MaxDecimalValidator } from './validators/max-decimals-validator.directive';
import { NonZeroValidator } from './validators/non-zero-validator.directive';
import { InputValidator } from './validators/input-validator.directive';
import { PhoneInputDirective } from './phone-input.directive';
import { RuralRoutePoBoxInputDirective } from './rural-route-po-box-input.directive';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    InputDirective,
    NumberInputDirective,
    InputValidator,
    MaxValueValidator,
    MinValueValidator,
    MaxDecimalValidator,
    NonZeroValidator,
    PhoneInputDirective,
    RuralRoutePoBoxInputDirective
  ],
  exports: [
    InputDirective,
    NumberInputDirective,
    InputValidator,
    MaxValueValidator,
    MinValueValidator,
    MaxDecimalValidator,
    NonZeroValidator,
    PhoneInputDirective,
    RuralRoutePoBoxInputDirective
  ]
})
export class InputModule {
}
